import styled from 'styled-components';
import { getZIndex } from '@yoweb/ui/styles/utils/theme';
import { ErrorBanner } from '@yoweb/ui/components/ErrorBanner';
/**
 * Displays an absolute positioned, dismissible error in a criticalLight colored container.
 * Useful in modals.
 */

import { jsx as _jsx } from "react/jsx-runtime";
export var ActionModalError = function ActionModalError(_ref) {
  var error = _ref.error,
      onErrorDismissed = _ref.onErrorDismissed;
  return /*#__PURE__*/_jsx(ErrorContainer, {
    "data-testid": "action-modal-error-banner",
    children: /*#__PURE__*/_jsx(ErrorBanner, {
      error: error,
      onErrorDismissed: onErrorDismissed,
      withBorderRadius: false
    })
  });
};
var ErrorContainer = styled.div.withConfig({
  componentId: "sc-12ijuo7-0"
})(["bottom:0;left:0;position:absolute;width:100%;z-index:", ";"], getZIndex('above'));